export default "__VITE_ASSET__Dc5qwqp3__"